import React from 'react';
import {useIntl} from 'react-intl';

import {TEXT} from './HeadManager.definition';

const HeadManager = () => {
  const {formatMessage} = useIntl();
  return <title>{formatMessage(TEXT.TITLE)}</title>;
};

export {HeadManager};
